<template>
  <section>
    <b-modal id="weekly-subscription-form" :title="$t('weekly-subscription-form.title')" centered>
      <b-form>
        <b-form-group :label="$t('weekly-subscription-form.label.email')" label-size="lg" label-for="email">
          <b-form-input id="email" v-model="email" trim></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('weekly-subscription-form.label.subscribe-or-unsubscribe')" label-size="lg">
          <b-form-radio-group>
            <b-form-radio v-model="subscribe_or_unsubscribe" name="subscribe_or_unsubscribe" value="subscribe">
              {{ $t('weekly-subscription-form.subscribe-or-unsubscribe-radio-button.option.subscribe.label') }}
            </b-form-radio>
            <b-form-radio v-model="subscribe_or_unsubscribe" name="subscribe_or_unsubscribe" value="unsubscribe">
              {{ $t('weekly-subscription-form.subscribe-or-unsubscribe-radio-button.option.unsubscribe.label') }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-row v-if="validation_result && !validation_result.succeeded">
          <b-col class="text-danger">
            <p class="font-weight-bold" v-for="field in validation_result.fieldErrors">{{ field.message }}</p>
          </b-col>
        </b-form-row>
      </b-form>
      <template #modal-footer="{ close }">
        <b-button class="w-50" variant="default" @click="close()">{{ $t('modal.button.cancel.label') }}</b-button>
        <b-button class="w-50" variant="success" @click="submitForm()">{{ $t('modal.button.submit.label') }}</b-button>
      </template>
    </b-modal>
    <b-modal id="weekly-subscription-message" :title="$t('weekly-subscription-form.title')" centered>
      <p
        v-if="subscribe_or_unsubscribe === 'subscribe'"
      >{{ $t('weekly-subscription-form.message.subscription-completed') }}</p>
      <p
        v-if="subscribe_or_unsubscribe === 'unsubscribe'"
      >{{ $t('weekly-subscription-form.message.unsubscription-completed') }}</p>
      <template #modal-footer="{ close }">
        <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
      </template>
    </b-modal>
  </section>
</template>
<script>
import Vue from 'vue'

import { ButtonPlugin } from 'bootstrap-vue'
import { FormGroupPlugin } from 'bootstrap-vue'
import { FormInputPlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { FormRadioPlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { Validators, createFormValidation } from '@lemoncode/fonk'

import i18n from '@/plugins/i18n.js'

import WeeklySubscriberApiService from '@/services/budaedu-api-services/weekly-subscriber-api-service.js'

Vue.use(ButtonPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormPlugin)
Vue.use(FormRadioPlugin)
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)

Vue.use(WeeklySubscriberApiService)

export default {
  i18n,
  name: 'weekly-subscription-form',
  data() {
    return {
      email: '',
      subscribe_or_unsubscribe: '',
      validation_schema: {
        field: {
          email: [
            { validator: Validators.required, message: '電子郵件未填寫' },
            { validator: Validators.email, message: '電子郵件格式不正確' }
          ],
          subscribe_or_unsubscribe: [{ validator: Validators.required, message: '您尚未選擇要訂閱或退訂' }]
        }
      },
      validation_result: null
    }
  },
  methods: {
    async submitForm() {
      await this.validateForm()

      if (this.validation_result.succeeded) {
        if (this.subscribe_or_unsubscribe === 'subscribe') {
          await this.$weeklySubscriberApiService.create({ email: this.email })
        } else if (this.subscribe_or_unsubscribe === 'unsubscribe') {
          await this.$weeklySubscriberApiService.deleteByEmail(this.email)
        }

        this.$bvModal.hide('weekly-subscription-form')

        if (this.subscribe_or_unsubscribe === 'subscribe' || this.subscribe_or_unsubscribe === 'unsubscribe') {
          this.$bvModal.show('weekly-subscription-message')
        }
      }
    },
    async validateForm() {
      const validation = createFormValidation(this.validation_schema)
      await validation
        .validateForm({ email: this.email, subscribe_or_unsubscribe: this.subscribe_or_unsubscribe })
        .then(form_validation_result => {
          this.validation_result = form_validation_result
        })
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>